import { apiMaybe, apiRequest } from '../../services/apiClient';

export function listGenerateTypes() {
  return apiMaybe('/generate/types');
}

export function listGenerateSessions() {
  return apiMaybe('/generate/sessions');
}

export function deleteGenerateSession(sessionId) {
  return apiRequest(`/generate/sessions/${sessionId}`, {
    method: 'DELETE',
  });
}

export function startGenerateSession(typeKey) {
  return apiRequest(`/generate/${typeKey}/start`, {
    method: 'POST',
  });
}

export function getGenerateSession(sessionId) {
  return apiRequest(`/generate/sessions/${sessionId}`);
}

export function answerGenerateQuestion(sessionId, response) {
  return apiRequest(`/generate/sessions/${sessionId}/answer`, {
    json: { response },
  });
}

export function renderGenerateSession(sessionId, { concludeEarly = false } = {}) {
  return apiRequest(`/generate/sessions/${sessionId}/render`, {
    method: 'POST',
    json: { concludeEarly },
  });
}

export function prefillGenerateSession(sessionId, notes) {
  return apiRequest(`/generate/sessions/${sessionId}/prefill`, {
    json: { notes },
  });
}

export function reviseGenerateSession(sessionId, questionIndex) {
  return apiRequest(`/generate/sessions/${sessionId}/revise`, {
    json: { questionIndex },
  });
}
